var _path, _path2, _circle, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m11.429 16a5.715 5.715 0 1 0 -5.715-5.714 5.72 5.72 0 0 0 5.715 5.714z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m18.905 20.721a10.434 10.434 0 0 0 -17.905 7.279 1 1 0 0 0 1 1h18.86a1 1 0 0 0 1-1 10.067 10.067 0 0 0 -.485-3.124 10.36 10.36 0 0 0 -2.47-4.155z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23.5,
    cy: 12.25,
    r: 4.25
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m23.5 17.67a7.482 7.482 0 0 0 -3.806 1.057c.217.194.436.385.641.595a12.388 12.388 0 0 1 2.952 4.966 11.488 11.488 0 0 1 .437 1.882h6.276a1 1 0 0 0 1-1 7.508 7.508 0 0 0 -7.5-7.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUsers);
export default __webpack_public_path__ + "static/media/icon-users.c7c138578daf1147ecf74131c6405e7f.svg";
export { ForwardRef as ReactComponent };